import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpContext } from '@angular/common/http';
import { USE_ADS_BASE } from 'src/app/core/http/http-context.tokens';

@Injectable({
  providedIn: 'root',
})
export class AdsService {
  constructor(private _http: HttpClient) {}

  private competitors = new BehaviorSubject<any>([]);
  private competitorsLoading = new BehaviorSubject<any>(false);
  private selectedCompetitor = new BehaviorSubject<any>(null);

  setCompetitors(competitors: any) {
    this.competitors.next(competitors);
  }
  getCompetitors() {
    return this.competitors.asObservable();
  }
  getCompetitorsLoading() {
    return this.competitorsLoading.asObservable();
  }
  fetchCompetitors(selectedCompetitor: boolean = false) {
    this.competitorsLoading.next(true);
    this.getCompetitorsAPI().subscribe({
      next: (res) => {
        this.setCompetitors(res);
        this.competitorsLoading.next(false);

        if (selectedCompetitor) {
          this.setSelectedCompetitor(res?.[0]);
        }
      },
      error: (err) => {
        console.log(err);
        this.competitorsLoading.next(false);
      },
    });
  }
  setSelectedCompetitor(competitor: any) {
    this.selectedCompetitor.next(competitor);
    sessionStorage.setItem('selectedCompetitor', JSON.stringify(competitor));
  }
  getSelectedCompetitor() {
    const competitor = sessionStorage.getItem('selectedCompetitor');

    try {
      if (competitor && competitor != undefined) {
        const parsedCompetitor = JSON.parse(competitor);
        this.selectedCompetitor.next(parsedCompetitor);
      }
    } catch (e) {
      console.log(e);
    }

    return this.selectedCompetitor.asObservable();
  }

  getProjects(): Observable<any> {
    return this._http.post(
      '/google-ads/get-projects',
      {},
      {
        context: new HttpContext().set(USE_ADS_BASE, true),
      }
    );
  }
  createProject(data: any): Observable<any> {
    return this._http.post('/google-ads/create-project', data, {
      context: new HttpContext().set(USE_ADS_BASE, true),
    });
  }
  getAdScores(data: any): Observable<any> {
    return this._http.post('/ads_manager/get-ad-scores', data, {
      context: new HttpContext().set(USE_ADS_BASE, true),
    });
  }
  measureAdCopy(data: any): Observable<any> {
    return this._http.post('/ads_manager/measure-ad-copy', data, {
      context: new HttpContext().set(USE_ADS_BASE, true),
    });
  }
  getKeywordsAIScore(data: any): Observable<any> {
    return this._http.post('/ads_manager/get-keywords-ai-score', data, {
      context: new HttpContext().set(USE_ADS_BASE, true),
    });
  }
  getKeywordsNegatives(data: any): Observable<any> {
    return this._http.post('/ads_manager/get-keyword-negatives', data, {
      context: new HttpContext().set(USE_ADS_BASE, true),
    });
  }
  getAllCampaigns(data: any): Observable<any> {
    return this._http.post('/ads_manager/get-all-campaigns', data, {
      context: new HttpContext().set(USE_ADS_BASE, true),
    });
  }
  getCompetitorsAPI(): Observable<any> {
    return this._http.get('/competitors/get-competitor-tasks', {
      context: new HttpContext().set(USE_ADS_BASE, true),
    });
  }
  createCompetitor(data: any): Observable<any> {
    return this._http.post('/competitors/get-competitor-data', data, {
      context: new HttpContext().set(USE_ADS_BASE, true),
    });
  }
  deleteCompetitor(data: any): Observable<any> {
    return this._http.post('/competitors/delete-competitor-tasks', data, {
      context: new HttpContext().set(USE_ADS_BASE, true),
    });
  }
  deleteProject(data: any): Observable<any> {
    return this._http.post('/google-ads/delete-projects', data, {
      context: new HttpContext().set(USE_ADS_BASE, true),
    });
  }
  getProjectStatus(data: any): Observable<any> {
    return this._http.post('/google-ads/get-project-status', data, {
      context: new HttpContext().set(USE_ADS_BASE, true),
    });
  }
}
